<template>
  <div>
    <div>
      <b-alert show variant="dark" class="margin-bottom font12px">
        <h6>Screening {{ this.vnChang }}</h6>
        <b-row class="margin-bottom">
          <b-col lg="6" class="margin-bottom">
            <b-alert variant="success" show>
              <div>
                <strong>T.</strong>
                {{
                  this.VisitScreeningData &&
                    pjFunctionsFc.strToFloat(
                      this.VisitScreeningData.datas.temperature
                    )
                }}
                °C | <strong>P.</strong>
                {{
                  this.VisitScreeningData &&
                    pjFunctionsFc.strToFloat(
                      this.VisitScreeningData.datas.pulse
                    )
                }}
                /min. | <strong>RR.</strong>
                {{
                  this.VisitScreeningData &&
                    pjFunctionsFc.strToFloat(this.VisitScreeningData.datas.rr)
                }}
                /min. | <strong>BP.</strong>
                {{
                  this.VisitScreeningData &&
                    pjFunctionsFc.strToFloat(this.VisitScreeningData.datas.bps)
                }}
                /
                {{
                  this.VisitScreeningData &&
                    pjFunctionsFc.strToFloat(this.VisitScreeningData.datas.bpd)
                }}
                mmHg | <strong>SpO2.</strong>
                {{
                  this.VisitScreeningData &&
                    pjFunctionsFc.strToFloat(this.VisitScreeningData.datas.spo2)
                }}
                % | <strong>FBS.</strong>
                {{
                  this.VisitScreeningData &&
                    pjFunctionsFc.strToFloat(this.VisitScreeningData.datas.fbs)
                }}

                | <strong>Height.</strong>
                {{
                  this.VisitScreeningData &&
                    pjFunctionsFc.strToFloat(
                      this.VisitScreeningData.datas.height
                    )
                }}
                | <strong>BW.</strong>
                {{
                  this.VisitScreeningData &&
                    pjFunctionsFc.strToFloat(this.VisitScreeningData.datas.bw)
                }}
                | <strong>BMI.</strong>
                {{
                  this.VisitScreeningData &&
                    pjFunctionsFc.strToFloat(this.VisitScreeningData.datas.bmi)
                }}

                | <strong>DTX.</strong>
                {{
                  this.VisitScreeningData &&
                    pjFunctionsFc.strToFloat(this.VisitScreeningData.datas.dtx1)
                }}
                /
                {{
                  this.VisitScreeningData &&
                    pjFunctionsFc.strToFloat(this.VisitScreeningData.datas.dtx2)
                }}
                | <strong>ความเร่งด่วน.</strong>
                {{
                  this.VisitScreeningData &&
                    this.VisitScreeningData.datas.pt_priority_name
                }}
              </div>
            </b-alert>
          </b-col>
          <b-col lg="6">
            <b-alert variant="info" show>
              <div
                v-html="
                  this.VisitScreeningData &&
                    '<strong>CC</strong> :' +
                      TextToHtml(this.VisitScreeningData.datas.cc)
                "
              ></div>

              <div
                v-if="
                  this.VisitScreeningData && this.VisitScreeningData.datas.hpi
                "
                v-html="
                  this.VisitScreeningData &&
                    '<strong>HPI</strong> :' +
                      TextToHtml(this.VisitScreeningData.datas.hpi)
                "
              ></div>

              <div
                v-if="
                  this.VisitScreeningData && this.VisitScreeningData.datas.pmh
                "
                v-html="
                  this.VisitScreeningData &&
                    '<strong>PMH</strong> :' +
                      TextToHtml(this.VisitScreeningData.datas.pmh)
                "
              ></div>

              <div
                v-if="
                  this.VisitScreeningData && this.VisitScreeningData.datas.fh
                "
                v-html="
                  this.VisitScreeningData &&
                    '<strong>FH</strong> :' +
                      TextToHtml(this.VisitScreeningData.datas.fh)
                "
              ></div>

              <div
                v-if="
                  this.VisitScreeningData && this.VisitScreeningData.datas.sh
                "
                v-html="
                  this.VisitScreeningData &&
                    '<strong>SH</strong> :' +
                      TextToHtml(this.VisitScreeningData.datas.sh)
                "
              ></div>

              <div
                v-if="
                  this.VisitScreeningData && this.VisitScreeningData.datas.ros
                "
                v-html="
                  this.VisitScreeningData &&
                    '<strong>ROS</strong> :' +
                      TextToHtml(this.VisitScreeningData.datas.ros)
                "
              ></div>
            </b-alert>
          </b-col>
        </b-row>
      </b-alert>
    </div>
  </div>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";
import feather from "vue-icon";
import store from "@/store/store";
import thaiDatetime from "@/functions/thaiDatetime";
import pjFunctions from "@/functions/pjFunctions";
import PatientScreening from "@/models/patientEMRs/PatientScreening";

Vue.use(feather, "v-icon");

@Component({
  data() {
    return {
      vnStart: "",
      thaiDatetimeFc: null,
      pjFunctionsFc: null,
      VisitScreeningData: null,
      apiCk: 0,
      ptHN: "",
      ptVN: "",
      ScreeningDataCh: ""
    };
  },
  props: ["MyVn", "MyHn"],
  component: {
    thaiDatetime,
    pjFunctions,
    PatientScreening
  },
  created() {
    this.thaiDatetimeFc = thaiDatetime.methods;
    this.pjFunctionsFc = pjFunctions.methods;
    // this.vnChang;
  },
  watch: {
    ptHN: function() {
      // this.setScreeningData(this.ptVN, this.ptHN);
    },
    ptVN: function() {
      this.setScreeningData(this.ptVN, this.ptHN);
      // this.getScreeningData(this.ptVN, this.ptHN);
    }
  },
  computed: {
    vnChang() {
      this.ptHN = this.MyHn;
      this.ptVN = this.MyVn;
    }
  },
  methods: {
    setScreeningData(vn, hn) {
      this.ScreeningDataCh = "StartVisitOPDVitalSign" + vn;

      if (vn != "" && vn != null) {
        let ScrObj = this;
        this.axios
          .post(this.$store.get("systems@UrlApi") + "VisitOPDVitalSign", {
            CompanyId: this.$store.get("systems@CompanyId"),
            ApiKey: this.$store.get("systems@ApiKey"),
            hn: hn,
            vn: vn
          })
          .then(function(response) {
            ScrObj.output = response.data;
            if (ScrObj.output.status === true) {
              PatientScreening.delete({
                where(record) {
                  return record.vn == vn;
                }
              });

              let data = [];
              for (var val of ScrObj.output.result) {
                data.push({
                  id: val.vn,
                  vn: val.vn,
                  hn: val.hn,
                  datas: val
                });
              }

              PatientScreening.insertOrUpdate({
                data
              });
            } else {
              if (ScrObj.output.ErrorMessage === "Data Not Found") {
                PatientScreening.delete({
                  where(record) {
                    return record.vn == vn;
                  }
                });
              }
            }
          })
          .catch(function(error) {
            ScrObj.output = error;
            console.log("VisitOPDVitalSign : " + ScrObj.output);
          })
          .finally(function() {
            ScrObj.ScreeningDataCh = "VisitOPDVitalSign" + vn;
            ScrObj.getScreeningData(vn, hn);
          });
      }
    },
    getScreeningData(vn, hn) {
      let ScrObj = PatientScreening.query()
        .where(record => record.datas.hn == hn)
        .where(record => record.datas.vn == vn)
        .get();

      if (ScrObj.length > 0) {
        this.VisitScreeningData = ScrObj[0];
        this.apiCk = this.apiCk + 1;
      } else {
        this.VisitScreeningData = null;
        this.apiCk = this.apiCk + 1;
      }
    },
    TextToHtml(txt) {
      if (txt != null && txt != "") {
        String.prototype.replaceAll = function(search, replacement) {
          var target = this;
          return target.split(search).join(replacement);
        };
        let PgNote = txt;
        PgNote = PgNote.replaceAll("\n", "<br>");

        return PgNote;
      } else {
        return "";
      }
    }
  }
})
export default class EmrScreeningOPD extends Vue {}
</script>

<style lang="scss">
</style>

